import {
  ADD_REPORT,
  FETCH_REPORT,
  GET_REPORT,
  GET_REPORT_LIST,
} from './actions/shipping'

export default {
  namespaced: true,
  state: {
    reports: {},
  },
  getters: {
    [GET_REPORT_LIST]: state => state.reports,
    [GET_REPORT]: state => state.reports,
  },
  mutations: {
    [FETCH_REPORT]: (state, payload) => (state.reports = payload),
  },
  actions: {
    [ADD_REPORT]: ({ commit }, payload) => {
      commit(FETCH_REPORT, payload)
    },
    [FETCH_REPORT]: ({ commit }, payload) => {
      commit(FETCH_REPORT, payload)
    },
  },
}
